import labubu1 from './labubu1.jpeg';
import labubu2 from './labubu2.png';
import labubu3 from './labubu3.png';
import labubu4 from './labubu4.png';
import labubu5 from './labubu5.png';
import labubu6 from './labubu6.png';
import labubu7 from './labubu7.png';
import labubu8 from './labubu8.png';
import labubu9 from './labubu9.png';
import labubu10 from './labubu10.png';
import labubu11 from './labubu11.png';
import labubu12 from './labubu12.png';
import labubu13 from './labubu13.png';
import labubu14 from './labubu14.png';
import labubu15 from './labubu15.jpg';
import labubu16 from './labubu16.png';
import labubu17 from './labubu17.jpg';
import labubu18 from './labubu18.jpg';
import labubu19 from './labubu19.png';
import labubu20 from './labubu20.png';
import labubu21 from './labubu21.jpg';
import labubu22 from './labubu22.jpg';
import labubu23 from './labubu23.jpg';
import labubu24 from './labubu24.jpg';
import labubu25 from './labubu25.jpg';
import labubu26 from './labubu26.jpg';
import labubu27 from './labubu27.jpg';
import labubu28 from './labubu28.jpg';
import labubu29 from './labubu29.jpg';
import labubu30 from './labubu30.jpg';
import labubu31 from './labubu31.png';
import labubu32 from './labubu32.png';
import labubu33 from './labubu33.png';
import labubu34 from './labubu34.jpeg';
import labubu35 from './labubu35.jpeg';
import labubu36 from './labubu36.jpeg';
import labubu37 from './labubu37.jpeg';
import labubu38 from './labubu38.jpeg';
import labubu39 from './labubu39.jpeg';
import lalabu40 from './lalabu40.jpeg';
import labubu41 from './labubu41.png';

const images = [
  { id: 1, src: labubu1, name: 'Labubu’s Poolside Chill' },
  { id: 2, src: labubu2, name: 'Labubu in the Starry Abyss' },
  { id: 3, src: labubu3, name: 'Peekaboo Labubu with Love' },
  { id: 4, src: labubu4, name: 'Rainbow Heart Labubu' },
  { id: 5, src: labubu5, name: 'Underwater Labubu' },
  { id: 6, src: labubu6, name: 'Rider Labubu' },
  { id: 7, src: labubu7, name: 'Sunny Day Labubu' },
  { id: 8, src: labubu8, name: 'Gamer Labubu' },
  { id: 9, src: labubu9, name: 'Mysterious Brown Bunny Labubu' },
  { id: 10, src: labubu10, name: 'Enchanted Forest Explorer Labubu' },
  { id: 11, src: labubu11, name: 'Poolside Adventurer Labubu' },
  { id: 12, src: labubu12, name: 'Neon Glow Bunny Labubu' },
  { id: 13, src: labubu13, name: 'labubu flashlight wallpaper' },
  { id: 14, src: labubu14, name: 'labubu flashlight wallpaper' },
  { id: 15, src: labubu15, name: 'labubu flashlight wallpaper' },
  { id: 16, src: labubu16, name: 'labubu love flashlight live photo' },
  { id: 17, src: labubu17, name: 'labubu hearts flashlight live wallpaper' },
  { id: 18, src: labubu18, name: 'Cozy Bedtime Labubu' },
  { id: 19, src: labubu19, name: 'Racing Labubu' },
  { id: 20, src: labubu20, name: 'F1 Driver Labubu' },
  { id: 21, src: labubu21, name: 'Pool Day Duo' },
  { id: 22, src: labubu22, name: 'Solo Pool Float' },
  { id: 23, src: labubu23, name: 'Labubu Trio Fun' },
  { id: 24, src: labubu24, name: 'Bunny Buddies' },
  { id: 25, src: labubu25, name: 'Peekaboo Labubu' },
  { id: 26, src: labubu26, name: 'Sleeping Beauty Labubu' },
  { id: 27, src: labubu27, name: 'Splash Play Labubu' },
  { id: 28, src: labubu28, name: 'Love Text Labubu' },
  { id: 29, src: labubu29, name: 'Dreaming Labubu Live Photo' },
  { id: 30, src: labubu30, name: 'Duck Float Labubu' },
  { id: 31, src: labubu31, name: 'Fluffy Labubu Live Photo' },
  { id: 32, src: labubu32, name: 'Pastel Dream Labubu Live Photo' },
  { id: 33, src: labubu33, name: 'Streetwear Labubu Live Photo' },
  { id: 34, src: labubu34, name: 'Racing Champion Labubu' },
  { id: 35, src: labubu35, name: 'Fitness Enthusiast Labubu Live Photo' },
  { id: 36, src: labubu36, name: 'Wild Yeti Labubu Live Photo' },
  { id: 37, src: labubu37, name: 'Underwater Bunny Labubu' },
  { id: 38, src: labubu38, name: 'Pink Monster Labubu' },
  { id: 39, src: labubu39, name: 'Crystal Water Labubu' },
  { id: 40, src: lalabu40, name: 'Bunny Hood Labubu Live Photo\n' },
  { id: 41, src: labubu41, name: 'Summer Vacation Labubu Live Photo' },
];

export default images;
